import Analytics from './Admin/Components/Analytics'
import ChangeEntryStatus from './Admin/Components/ChangeEntryStatus'
import Clipboard from './Admin/Components/Clipboard'
import DocumentUploader from './Admin/Components/DocumentUploader'
import { headerIconRect, isPointerOverHeaderIcon } from './Admin/headerIconTooltip'
import preserveModalScroll from './Admin/preserveModalScroll'

window.Components = {}
window.Components.changeEntryStatus = ChangeEntryStatus
window.Components.documentUploader = DocumentUploader
window.Components.clipboard = Clipboard
window.Components.analytics = Analytics
window.Components.headerIconRect = headerIconRect
window.Components.isPointerOverHeaderIcon = isPointerOverHeaderIcon

preserveModalScroll()
